// A sleeping authentication PR deploy answers 503 until it is back up (leela wakes it on the first request).
// Ask once with a simple request, which needs no preflight a sleeping PR can't answer, and wait as told.
const DEFAULT_RETRY_SECONDS = 2;
// Waking takes about 10 s; past this, boot anyway and let the console show its own errors.
export const MAX_WAIT_MS = 60000;

function retryDelayMs(response) {
    const seconds = Number(response.headers.get('Retry-After'));
    return (Number.isFinite(seconds) && seconds > 0 ? seconds : DEFAULT_RETRY_SECONDS) * 1000;
}

const sleep = (ms) =>
    new Promise((resolve) => {
        setTimeout(resolve, ms);
    });

// Fetch aborted after `ms`: a request that never settles must not hold the console past the deadline.
async function fetchWithin(fetchImpl, url, init, ms) {
    const controller = new AbortController();
    const timer = setTimeout(() => controller.abort(), ms);
    try {
        return await fetchImpl(url, { ...init, signal: controller.signal });
    } finally {
        clearTimeout(timer);
    }
}

// Resolves once the deploy answers anything but 503, after a network error or abort (no CORS on the answer:
// nothing to wait on), or once MAX_WAIT_MS of wall-clock time is spent, requests included. Calls onWaiting the
// first time it has to wait.
export async function waitForAuthPr(
    authUrl,
    { onWaiting = () => {}, fetchImpl = fetch, wait = sleep, now = Date.now } = {},
) {
    const deadline = now() + MAX_WAIT_MS;
    let waiting = false;
    for (let left = MAX_WAIT_MS; left > 0; left = deadline - now()) {
        let response;
        try {
            // eslint-disable-next-line no-await-in-loop
            response = await fetchWithin(
                fetchImpl,
                `${authUrl}/`,
                { headers: { Accept: 'application/json' }, credentials: 'omit' },
                left,
            );
        } catch (e) {
            return;
        }
        if (response.status !== 503) return;
        if (!waiting) {
            waiting = true;
            onWaiting();
        }
        // eslint-disable-next-line no-await-in-loop
        await wait(Math.min(retryDelayMs(response), Math.max(deadline - now(), 0)));
    }
}
